<template>
  <form class="form contact-us-faq-form" @submit.prevent="handleSearch()">
    <img data-src="@/assets/images/search-field-shadow.png" class="shadow"
      src="@/assets/images/search-field-shadow.png">
    <span class="clearable"><input ref="search" class="search-field form-control clearable" name="filter"
        :placeholder="$t('general.search-place-holder')">
      <div class="clearable--btn" style="top: 24px; right: 24px; z-index: 11;"></div>
    </span>
  </form>
</template>

<script>
export default {
  methods: {
    handleSearch() {
      // Send data to the server or update your stores and such.
      if (this.$refs["search"].value) {
        this.$router.push({ path: '/resources/faq', query: { q: this.$refs["search"].value } })
      }
    }
  }  
}
</script>